// eTAMS shared constants & status mappings (TSE-HR-TAE-001 / TSE-HR-TEC-001)

export const MODES_OF_TRAVEL = [
  'Rail · AC3', 'Rail · AC2', 'Rail · AC1', 'Rail · Chair car', 'Rail · Sleeper',
  'Air · Economy', 'Bus', 'Company car', 'Own car', 'Two-wheeler', 'Taxi / Cab',
];

// Expense line categories — values map 1:1 to the backend enum
export const EXPENSE_CATEGORIES = [
  'Rail Fare', 'Air Ticket', 'Bus Fare', 'Hotel', 'Local Conveyance', 'Taxi / Auto / Cab', 'Airport Cab',
  'Food + OPE', 'Meals (DA)', 'Own Vehicle (km)', 'Toll / Parking', 'Communication', 'Miscellaneous', 'Others',
];
export const PAID_BY = ['Employee', 'Company', 'Client'];

// Groups used by the overview donut
export const CATEGORY_GROUP = {
  'Rail Fare': 'Travel', 'Air Ticket': 'Travel', 'Bus Fare': 'Travel', 'Airport Cab': 'Travel',
  Hotel: 'Hotel',
  'Food + OPE': 'Food', 'Meals (DA)': 'Food',
  'Local Conveyance': 'Local transport', 'Taxi / Auto / Cab': 'Local transport', 'Own Vehicle (km)': 'Local transport', 'Toll / Parking': 'Local transport',
};
export const GROUP_COLORS = { Travel: '#1a8ad4', Hotel: '#1fa39a', Food: '#f2b541', 'Local transport': '#a37ee8', Others: '#c5ced8' };

export const DOCUMENT_TYPES = ['Hotel invoice', 'Rail ticket', 'Air ticket', 'Bus ticket', 'Cab receipt', 'Food bill', 'Fuel bill', 'Toll / Parking', 'Other'];
export const DOC_TO_CATEGORY = {
  'Hotel invoice': 'Hotel', 'Rail ticket': 'Rail Fare', 'Air ticket': 'Air Ticket', 'Bus ticket': 'Bus Fare',
  'Cab receipt': 'Local Conveyance', 'Food bill': 'Food + OPE', 'Fuel bill': 'Own Vehicle (km)', 'Toll / Parking': 'Toll / Parking', Other: 'Others',
};

// Claim status → PDF wording
export function claimStatus(c) {
  switch (c?.status) {
    case 'DRAFT': return { label: c.returnedCount ? 'Returned' : 'Draft', tone: c.returnedCount ? 'rejected' : 'draft', icon: c.returnedCount ? 'bi-arrow-return-left' : 'bi-file-earmark' };
    case 'SUBMITTED': return { label: 'Pending', tone: 'pending', icon: 'bi-clock' };
    case 'MANAGER_APPROVED': return { label: 'In review', tone: 'review', icon: 'bi-hourglass-split' };
    case 'FINANCE_APPROVED': return { label: 'Approved', tone: 'approved', icon: 'bi-check-circle' };
    case 'SETTLED': return { label: 'Paid', tone: 'paid', icon: 'bi-check-circle' };
    case 'REJECTED': return { label: 'Rejected', tone: 'rejected', icon: 'bi-x-circle' };
    default: return { label: c?.status || '—', tone: 'gray', icon: 'bi-circle' };
  }
}

export function advanceStatus(a) {
  switch (a?.status) {
    case 'DRAFT': return { label: 'Draft', tone: 'draft' };
    case 'PENDING_MANAGER': return { label: 'Pending', tone: 'pending', sub: 'Manager' };
    case 'PENDING_FINANCE': return { label: 'Pending', tone: 'pending', sub: 'Accounts' };
    case 'APPROVED': return { label: 'Approved', tone: 'approved' };
    case 'REJECTED': return { label: 'Rejected', tone: 'rejected' };
    default: return { label: a?.status || '—', tone: 'gray' };
  }
}
export const releaseStatus = (a) => ((a?.advanceReleasedAmount || 0) > 0
  ? { label: 'Released', tone: 'approved' }
  : a?.status === 'REJECTED' ? { label: '—', tone: 'gray' } : { label: 'Not released', tone: 'pending' });

export function travelStatus(t) {
  switch (t?.status) {
    case 'DRAFT': return { label: 'Draft', tone: 'draft', icon: 'bi-file-earmark' };
    case 'RETURNED': return { label: 'Returned', tone: 'rejected', icon: 'bi-arrow-return-left' };
    case 'PENDING_MANAGER': return { label: 'Pending', tone: 'pending', icon: 'bi-clock', stage: 'Reporting manager' };
    case 'PENDING_HOD': return { label: 'Pending', tone: 'pending', icon: 'bi-clock', stage: 'HOD' };
    case 'PENDING_ADMIN': return { label: 'Pending', tone: 'pending', icon: 'bi-clock', stage: 'Booking desk' };
    case 'APPROVED': return { label: 'Approved', tone: 'approved', icon: 'bi-check-circle-fill' };
    case 'COMPLETED': return { label: 'Completed', tone: 'paid', icon: 'bi-check2-all' };
    case 'REJECTED': return { label: 'Rejected', tone: 'rejected', icon: 'bi-x-circle' };
    case 'CANCELLED': return { label: 'Cancelled', tone: 'draft', icon: 'bi-slash-circle' };
    default: return { label: t?.status || '—', tone: 'gray' };
  }
}

export const netOf = (c) => (c?.approvedAmount ?? c?.currentAmount ?? c?.netPayable ?? 0);
export const attachmentsOf = (r) => (r?.attachments?.length ? r.attachments : r?.attachment?.fileName ? [r.attachment] : []);
export const idOf = (x) => String(x?._id || x || '');

// Policy helpers
export function bandOf(policy, band) {
  return (policy?.bands || []).find((b) => b.band === band) || null;
}
export function policyCaps(policy, band, tier = 'C') {
  const b = bandOf(policy, band);
  if (!b) return null;
  return { hotel: b[`hotel${tier}`] ?? b.hotelC, food: b.food, ope: b.ope, ownStay: b.ownStay };
}
